import gql from 'graphql-tag';

import type { AllInstructionsData } from 'src/data/generation';
import type { UrlExtraction } from 'src/data/types';
import { executeGqlMutation, type GqlCallVariables } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp, throwIfResultHasErrors } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ClassifyTemplate(
    $customerId: ID!
    $allInstructionsData: JSON!
    $toolList: JSON!
    $urlExtractions: [UrlExtractionInput!]
  ) {
    classifyTemplate(
      customerId: $customerId
      allInstructionsData: $allInstructionsData
      toolList: $toolList
      urlExtractions: $urlExtractions
    )
  }
`;

interface Variables extends GqlCallVariables {
  customerId: ID;
  allInstructionsData: AllInstructionsData;
  toolList: Record<string, string>;
  urlExtractions: UrlExtraction[];
}

export const classifyTemplate = async (variables: Variables): Promise<string | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      ...variables,
      allInstructionsData: stringifyIfPresent(variables.allInstructionsData),
      toolList: stringifyIfPresent(variables.toolList),
    },
    options: {
      traceAcRequests: true,
    },
  });
  throwIfResultHasErrors(result);

  return getSingleProp<string>(result.data);
};
